import { useTranslation } from 'react-i18next';
import { Calendar } from 'components/Calendar/Calendar';
import { Legend } from 'components/Charts/Legend';
import { WeightIndicator, WeightMeasurement } from 'models/weight';
import { getWeightIndicatorColor } from 'utils/measurements/weight';
import { WeightCalendarBadge } from 'components/Calendar/WeightCalendarBadge';
import { usePatientDetailContext } from 'context/hooks';
import { useWeightMeasurements } from 'hooks/api/useWeightData';
import { PaperWithBorder } from 'components/PaperWithBorder';

export const WeightCalendarEvents = () => {
  const { t } = useTranslation();
  const { startDate, endDate, unitSystem } = usePatientDetailContext();
  const { data, isLoading, handleSelect, getItemById } = useWeightMeasurements();

  const weightLegendItems = [
    { color: getWeightIndicatorColor(WeightIndicator.Underweight), title: t('indicator_label_underweight') },
    { color: getWeightIndicatorColor(WeightIndicator.Normal), title: t('indicator_label_normal') },
    { color: getWeightIndicatorColor(WeightIndicator.Overweight), title: t('indicator_label_overweight') },
    { color: getWeightIndicatorColor(WeightIndicator.Obesity), title: t('indicator_label_obesity') },
  ];

  return (
    <PaperWithBorder isLoading={isLoading} title={t('patients_calendar_title')} testId={'weight-calendar'}>
      <Legend items={weightLegendItems} />
      <Calendar
        range={{
          startDate,
          endDate,
        }}
        events={
          data
            ? data?.map((item: WeightMeasurement, index) => ({
                id: item.id || `patientWeightMeasurements-${index}`,
                date: item.data.recordedTimestamp || 0,
              }))
            : []
        }
        renderItem={(calendarItem) => (
          <WeightCalendarBadge
            key={calendarItem.id}
            fullItem={getItemById(calendarItem.id) as WeightMeasurement}
            onClick={(id) => handleSelect(id)}
            unitSystem={unitSystem}
          />
        )}
      />
    </PaperWithBorder>
  );
};
